<template>
	<el-dialog :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
		<el-form :model="form">
			<el-form-item :label-width="formLabelWidth" v-for="(item, index) in fieldContrast" :key="index" :label="item.chfieldName">
				<el-input  v-model="form[item.enfieldName]" :disabled="disabled" autocomplete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="medium" @click="dialogFormVisible = false">取 消</el-button>
			<el-button size="medium" type="primary" @click="dialogFormVisible = false">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		fieldContrast: {
			type: Array
		}
	},

	data() {
		return {
			id:'',
			dialogFormVisible: false,
			disabled: true,
			title:'查看详情',
			form: {},
			formLabelWidth: '120px'
		};
	},
	created() {},
	methods: {
		loadData() {
			this.id = this.$route.query.id;
			console.log('详情', this.fieldContrast);
			console.log('详情', this.form)
			this.dialogFormVisible = true;
			
		}
	}
};
</script>

<style></style>
